// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module__container___1azEM","tos":"style-module__tos___2w7ul"};